import React from 'react';
import './index.scss';
import Loader from 'react-loaders';
import { Link } from 'react-router-dom';

const EcoDataPlatform = () => {
  return (
    <>
      <div className="container ecodataplatform-page">
        <div className="text-zone">
          <h1 className="text-hover">Eco Data Platform</h1>
          <p>
            An interactive data platform built with Streamlit, interfacing with
            the World Bank API across <b>84 indicators</b> and <b>184 countries</b>.
            Features a deployed ML model and an LLM-powered Hypothesis Generator —
            reducing app-switching and saving time <b>12x</b> compared to manual workflows.
          </p>
          <p>
            Built with <b>Python · NumPy · Gemini API · Streamlit · ML Deployment</b>
          </p>
          <Link to="/about" className="flat-button">BACK TO PROJECTS</Link>
        </div>
        <div className="embed-zone">
          <iframe
            src="https://sher213-ecodataplatform.streamlit.app/?embed=true"
            title="Eco Data Platform"
            allow="fullscreen"
          />
        </div>
      </div>
      <Loader type="square-spin" />
    </>
  );
};

export default EcoDataPlatform;
